"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[303],{

/***/ 57573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CA": function() { return /* binding */ alertIdFromSlug; },
/* harmony export */   "DE": function() { return /* binding */ editSponsorAnswers; },
/* harmony export */   "FI": function() { return /* binding */ fetchSponsorships; },
/* harmony export */   "Nl": function() { return /* binding */ fetchSponsorForm; },
/* harmony export */   "QC": function() { return /* binding */ grantFaqToReofferBuyer; },
/* harmony export */   "TD": function() { return /* binding */ startFaqSponsorCheckout; },
/* harmony export */   "Vp": function() { return /* binding */ declineSponsorAnswers; },
/* harmony export */   "sM": function() { return /* binding */ startFaqSponsorRenewal; },
/* harmony export */   "so": function() { return /* binding */ approveSponsorAnswers; },
/* harmony export */   "wK": function() { return /* binding */ submitSponsorAnswers; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10092);
/* harmony import */ var api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46979);



// Evergreen Sponsor. Called on the raw axios instance, like api/newsroom.js,
// so the API's message and status reach the page.
var unwrap = function(res) {
    return res.data.data;
};
// The slug comes from the URL, so it must not be able to steer the request elsewhere.
var alertIdFromSlug = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(slug) {
        var alert;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/alerts/slug/".concat(encodeURIComponent(slug)))
                    ];
                case 1:
                    alert = unwrap.apply(void 0, [
                        _state.sent()
                    ]);
                    if (!Number.isInteger(alert === null || alert === void 0 ? void 0 : alert.id)) throw new Error("Alert not found");
                    return [
                        2,
                        alert.id
                    ];
            }
        });
    });
    return function alertIdFromSlug(slug) {
        return _ref.apply(this, arguments);
    };
}();
// The Stripe Checkout URL for a responder buying the slot. 409 when it is gone.
var startFaqSponsorCheckout = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(slug) {
        var _, _1, _2;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ = api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post;
                    _2 = (_1 = "/stripe/checkout/session/faq-sponsor/").concat;
                    return [
                        4,
                        alertIdFromSlug(slug)
                    ];
                case 1:
                    return [
                        4,
                        _.apply(api__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP, [
                            _2.apply(_1, [
                                _state.sent()
                            ])
                        ])
                    ];
                case 2:
                    return [
                        2,
                        _state.sent().data
                    ];
            }
        });
    });
    return function startFaqSponsorCheckout(slug) {
        return _ref.apply(this, arguments);
    };
}();
var startFaqSponsorRenewal = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(slug) {
        var _, _1, _2;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ = api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post;
                    _2 = (_1 = "/stripe/checkout/session/faq-sponsor/").concat;
                    return [
                        4,
                        alertIdFromSlug(slug)
                    ];
                case 1:
                    return [
                        4,
                        _.apply(api__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP, [
                            _2.apply(_1, [
                                _state.sent(),
                                "/renewal"
                            ])
                        ])
                    ];
                case 2:
                    return [
                        2,
                        _state.sent().data
                    ];
            }
        });
    });
    return function startFaqSponsorRenewal(slug) {
        return _ref.apply(this, arguments);
    };
}();
var fetchSponsorForm = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/faq-sponsor/".concat(alertId))
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function fetchSponsorForm(alertId) {
        return _ref.apply(this, arguments);
    };
}();
var submitSponsorAnswers = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId, body) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].put */ .ZP.put("/faq-sponsor/".concat(alertId, "/answers"), body)
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function submitSponsorAnswers(alertId, body) {
        return _ref.apply(this, arguments);
    };
}();
var fetchSponsorships = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var ref, _page, page, _size, size;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, _page = ref.page, page = _page === void 0 ? 1 : _page, _size = ref.size, size = _size === void 0 ? 20 : _size;
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/faq-sponsor", {
                            params: {
                                page: page,
                                size: size
                            }
                        })
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function fetchSponsorships() {
        return _ref.apply(this, arguments);
    };
}();
var editSponsorAnswers = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId, body) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].put */ .ZP.put("/faq-sponsor/".concat(alertId, "/review"), body)
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function editSponsorAnswers(alertId, body) {
        return _ref.apply(this, arguments);
    };
}();
var approveSponsorAnswers = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post("/faq-sponsor/".concat(alertId, "/approve"))
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function approveSponsorAnswers(alertId) {
        return _ref.apply(this, arguments);
    };
}();
// The API's message says whether there is a payment to refund.
var declineSponsorAnswers = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId, reason) {
        var res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post("/faq-sponsor/".concat(alertId, "/decline"), {
                            reason: reason
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        {
                            story: unwrap(res),
                            message: res.data.message
                        }
                    ];
            }
        });
    });
    return function declineSponsorAnswers(alertId, reason) {
        return _ref.apply(this, arguments);
    };
}();
var grantFaqToReofferBuyer = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post("/faq-sponsor/".concat(alertId, "/reoffer-buyer"))
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function grantFaqToReofferBuyer(alertId) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 5812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Em": function() { return /* binding */ reofferGrantBlocker; },
/* harmony export */   "Ht": function() { return /* binding */ countWords; },
/* harmony export */   "RT": function() { return /* binding */ publicationOfferText; },
/* harmony export */   "So": function() { return /* binding */ offerSendChoice; },
/* harmony export */   "WP": function() { return /* binding */ alertStillOpen; },
/* harmony export */   "XO": function() { return /* binding */ websiteLabel; },
/* harmony export */   "Yp": function() { return /* binding */ publicationOffer; },
/* harmony export */   "ao": function() { return /* binding */ faqQuestionInputs; },
/* harmony export */   "jb": function() { return /* binding */ MAX_ANSWER_WORDS; },
/* harmony export */   "nU": function() { return /* binding */ sponsorCheckoutError; },
/* harmony export */   "oo": function() { return /* binding */ faqSponsorStatusLabel; },
/* harmony export */   "sZ": function() { return /* binding */ publicationOfferBlocker; }
/* harmony export */ });
/* unused harmony export FAQ_QUESTIONS */
/* harmony import */ var _newsroom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93889);
/* harmony import */ var _research_sponsor_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25374);


var FAQ_QUESTIONS = 5;
var MAX_ANSWER_WORDS = 130;
var countWords = function(text) {
    return (text || "").trim().split(/\s+/).filter(Boolean).length;
};
// The firm's name, or the site's own name when the profile has none to link.
var websiteLabel = function(firm, website) {
    if (firm) return firm;
    try {
        return new URL(website).hostname.replace(/^www\./, "");
    } catch (e) {
        return null;
    }
};
var ref;
// Always five inputs in the Storify form; blanks are dropped by the API.
var faqQuestionInputs = function(questions) {
    return Array.from({
        length: FAQ_QUESTIONS
    }, function(_, i) {
        return (ref = questions === null || questions === void 0 ? void 0 : questions[i]) !== null && ref !== void 0 ? ref : "";
    });
};
// The story's one offer, once it has gone: the £50 FAQ offer, or the full sponsorship
// (the research sponsorship's re-offer). `notified` false: its email failed, Send retries it.
var publicationOffer = function(story, row) {
    if (story === null || story === void 0 ? void 0 : story.faqOfferSentAt) return {
        choice: "faq",
        at: story.faqOfferSentAt
    };
    if (row === null || row === void 0 ? void 0 : row.reofferOpenedAt) {
        return {
            choice: "full",
            at: row.reofferOpenedAt,
            endsAt: row.reofferEndsAt,
            pricePence: row.pricePence,
            notified: Boolean(row.reofferNotifiedAt)
        };
    }
    return null;
};
// What Send would send: nothing once the offer has gone, unless its full sponsorship email failed.
var offerSendChoice = function(offer, choice) {
    if (!offer) return choice;
    return offer.choice === "full" && !offer.notified ? "full" : "none";
};
var publicationOfferText = function(offer) {
    if (!offer) return null;
    if (offer.choice === "faq") {
        return "FAQ sponsorship (\xa350+VAT) emailed to the responders on ".concat((0,_newsroom_js__WEBPACK_IMPORTED_MODULE_0__/* .formatDate */ .p6)(offer.at), ". One offer per story.");
    }
    var opened = "Full sponsorship offered at ".concat((0,_research_sponsor_js__WEBPACK_IMPORTED_MODULE_1__/* .priceLabel */ .gX)(offer.pricePence), "+VAT on ").concat((0,_newsroom_js__WEBPACK_IMPORTED_MODULE_0__/* .formatDate */ .p6)(offer.at), ", open to the respondents until ").concat((0,_newsroom_js__WEBPACK_IMPORTED_MODULE_0__/* .formatDate */ .p6)(offer.endsAt), ".");
    return offer.notified ? "".concat(opened, " One offer per story.") : "".concat(opened, " Its email did not go: send it again.");
};
// As the API reads it: taking responses until its deadline. Stories are published once it
// closes, and the full sponsorship is offered only then (Dom, Asana #4, 4 Nov).
var alertStillOpen = function(alert) {
    var now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
    return (alert === null || alert === void 0 ? void 0 : alert.status) === "active" && !(alert.deadline && new Date(alert.deadline).getTime() < now);
};
// Why Send can't go yet. The API checks the same and has the last word.
var publicationOfferBlocker = function(param) {
    var choice = param.choice, alert = param.alert, story = param.story, row = param.row, dirty = param.dirty, pricePence = param.pricePence, _now = param.now, now = _now === void 0 ? Date.now() : _now;
    var ref;
    if (!(story === null || story === void 0 ? void 0 : story.publishedAt)) return "Publish the story first.";
    if (dirty) return "Save the story first: the offer uses the saved questions.";
    if (!story.faqHeading || !((ref = story.faqQuestions) === null || ref === void 0 ? void 0 : ref.length)) {
        return "Save the FAQ heading and at least one question first.";
    }
    if (story.faqSponsorStatus) return "The expert answers slot is already taken.";
    if (row && row.status !== "available") {
        return row.status === "sold" ? "The story sponsorship is already sold." : "A story sponsorship checkout is in progress.";
    }
    if (choice !== "full") return null;
    if (alertStillOpen(alert, now)) {
        return "Close the alert first: the full sponsorship goes out once it has closed.";
    }
    return pricePence ? null : "Enter the price in whole pounds, up to \xa35,000.";
};
// The API gives a re-offer buyer the slot with the saved heading and questions.
var reofferGrantBlocker = function(story, draft) {
    var ref;
    if (!(story === null || story === void 0 ? void 0 : story.publishedAt)) return "Publish the story first.";
    if (!story.faqHeading || !((ref = story.faqQuestions) === null || ref === void 0 ? void 0 : ref.length)) {
        return "Save the FAQ heading and at least one question first.";
    }
    var saved = [
        story.faqHeading,
        story.faqQuestions
    ];
    var current = [
        draft.faqHeading.trim(),
        draft.faqQuestions.map(function(q) {
            return q.trim();
        }).filter(Boolean), 
    ];
    return JSON.stringify(saved) === JSON.stringify(current) ? null : "Save the story first: the buyer answers the saved questions.";
};
var STATUS_TEXT = {
    awaiting_answers: "Paid, waiting for the sponsor’s answers",
    in_review: "Answers in review",
    live: "Expert answers live",
    declined: "Declined",
    expired: "Expired"
};
// For the Storify panel: where the story's sponsorship is, if anyone has paid.
var faqSponsorStatusLabel = function(story) {
    var text = STATUS_TEXT[story === null || story === void 0 ? void 0 : story.faqSponsorStatus];
    if (!text) return null;
    var running = [
        "awaiting_answers",
        "in_review",
        "live"
    ].includes(story.faqSponsorStatus);
    // No end date: it came free with a full sponsorship.
    var until = !running ? "" : story.faqSponsorExpiresAt ? " \xb7 runs until ".concat((0,_newsroom_js__WEBPACK_IMPORTED_MODULE_0__/* .formatDate */ .p6)(story.faqSponsorExpiresAt)) : " \xb7 runs with the story sponsorship";
    return "".concat(text).concat(until);
};
// What the pay page says when the API turns a responder away.
var sponsorCheckoutError = function(response) {
    var renewing = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var ref;
    if ((response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.code) === "ALREADY_SPONSOR") return "yours";
    if (renewing && (response === null || response === void 0 ? void 0 : response.status) === 404) return "nothingToRenew";
    if ((response === null || response === void 0 ? void 0 : response.status) === 409) return "taken";
    if ((response === null || response === void 0 ? void 0 : response.status) === 403) return "notResponder";
    if ((response === null || response === void 0 ? void 0 : response.status) === 404) return "notOffered";
    return "failed";
};


/***/ }),

/***/ 25374:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BA": function() { return /* binding */ researchOfferLocked; },
/* harmony export */   "FS": function() { return /* binding */ storedReservation; },
/* harmony export */   "K": function() { return /* binding */ RESEARCH_TEXT_MAX; },
/* harmony export */   "KA": function() { return /* binding */ reserveErrorMessage; },
/* harmony export */   "MR": function() { return /* binding */ researchAdminStatus; },
/* harmony export */   "Ps": function() { return /* binding */ researchReofferSold; },
/* harmony export */   "RY": function() { return /* binding */ RESEARCH_TEXT_TOO_LONG; },
/* harmony export */   "Sh": function() { return /* binding */ researchOfferError; },
/* harmony export */   "U6": function() { return /* binding */ researchOfferBody; },
/* harmony export */   "XE": function() { return /* binding */ storeReservation; },
/* harmony export */   "__": function() { return /* binding */ researchOfferDraft; },
/* harmony export */   "dS": function() { return /* binding */ researchOfferChanged; },
/* harmony export */   "df": function() { return /* binding */ forgetReservation; },
/* harmony export */   "dp": function() { return /* binding */ researchTextTooLong; },
/* harmony export */   "fp": function() { return /* binding */ RESEARCH_PRICES; },
/* harmony export */   "gX": function() { return /* binding */ priceLabel; },
/* harmony export */   "mf": function() { return /* binding */ researchBoxView; },
/* harmony export */   "r5": function() { return /* binding */ offerPricePence; },
/* harmony export */   "rg": function() { return /* binding */ researchReofferOpen; },
/* harmony export */   "uP": function() { return /* binding */ researchKeepsSlotsOff; }
/* harmony export */ });
/* unused harmony exports MAX_OFFER_POUNDS, RESERVATION_MAX_AGE_MS, parseStoredReservation */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _newsroom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93889);
// Story sponsorship (research): one company pays to be named as sponsor of the
// research behind an admin's News Alert and its story.


// The API accepts only these, in pence.
var RESEARCH_PRICES = [
    10000,
    25000,
    50000,
    75000,
    100000
];
var DEFAULT_PRICE = 50000;
var priceLabel = function(pence) {
    return new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency: "GBP",
        minimumFractionDigits: pence % 100 ? 2 : 0
    }).format(pence / 100);
};
// The admin's whole intro paragraph; the API allows the same.
var RESEARCH_TEXT_MAX = 600;
var RESEARCH_TEXT_TOO_LONG = "Shorten the sponsorship text to ".concat(RESEARCH_TEXT_MAX, " characters.");
// Like the API, a text saved before the limit may stay as it is; a changed one must fit.
var researchTextTooLong = function(draft, storedText) {
    var text = ((draft === null || draft === void 0 ? void 0 : draft.researchDetail) || "").trim();
    return text.length > RESEARCH_TEXT_MAX && text !== (storedText !== null && storedText !== void 0 ? storedText : "");
};
var ref, ref1;
var researchOfferDraft = function(row) {
    return {
        enabled: Boolean(row === null || row === void 0 ? void 0 : row.enabled),
        researchDetail: (ref = row === null || row === void 0 ? void 0 : row.researchDetail) !== null && ref !== void 0 ? ref : "",
        pricePence: (ref1 = row === null || row === void 0 ? void 0 : row.pricePence) !== null && ref1 !== void 0 ? ref1 : DEFAULT_PRICE
    };
};
// The API refuses any change once a buyer has reserved or paid.
var researchOfferLocked = function(row) {
    return Boolean(row) && row.status !== "available";
};
// The full sponsorship, offered in Storify at publication, runs a week for the alert's respondents.
var researchReofferOpen = function(row) {
    return Boolean(row === null || row === void 0 ? void 0 : row.reofferOpenedAt) && row.status === "available";
};
// A re-offer buyer has paid for the story's sponsor slot too.
var researchReofferSold = function(row) {
    return Boolean(row === null || row === void 0 ? void 0 : row.reofferOpenedAt) && row.status === "sold";
};
var researchAdminStatus = function(row) {
    var now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
    var reoffer = (row === null || row === void 0 ? void 0 : row.reofferOpenedAt) ? " (re-offer to respondents)" : "";
    if ((row === null || row === void 0 ? void 0 : row.status) === "sold") {
        return "Sold to ".concat(row.sponsorName || "…").concat(reoffer);
    }
    if ((row === null || row === void 0 ? void 0 : row.status) === "reserved") {
        return "Checkout in progress (".concat(row.sponsorName || "buyer", ")").concat(reoffer);
    }
    if (researchReofferOpen(row)) {
        var ends = (0,_newsroom_js__WEBPACK_IMPORTED_MODULE_0__/* .formatDate */ .p6)(row.reofferEndsAt);
        return new Date(row.reofferEndsAt).getTime() > now && row.enabled ? "Re-offered to respondents until ".concat(ends) : "Re-offer to respondents ended ".concat(ends, ", unsold");
    }
    return null;
};
// The full sponsorship's price is typed in whole pounds at publication; the API allows up to this.
var MAX_OFFER_POUNDS = 5000;
// Pence for a whole-pound price, or null.
var offerPricePence = function(text) {
    var value = String(text !== null && text !== void 0 ? text : "").trim().replace(/^£/, "").replace(/,/g, "");
    if (!/^\d+$/.test(value)) return null;
    var pounds = Number(value);
    return pounds >= 1 && pounds <= MAX_OFFER_POUNDS ? pounds * 100 : null;
};
// Caught before any request, so a create never leaves half a save behind.
var researchOfferError = function(draft) {
    var storedText = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    if (!(draft === null || draft === void 0 ? void 0 : draft.enabled)) return null;
    if (!draft.researchDetail.trim()) {
        return "Write the sponsorship text before offering the story sponsorship.";
    }
    return researchTextTooLong(draft, storedText) ? RESEARCH_TEXT_TOO_LONG : null;
};
// Without a detail the API keeps the stored one, so switching off loses nothing.
var researchOfferBody = function(draft) {
    var researchDetail = draft.researchDetail.trim();
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        enabled: draft.enabled,
        pricePence: draft.pricePence
    }, researchDetail ? {
        researchDetail: researchDetail
    } : {});
};
// Same rule as the API: an enabled offer, or one that is reserved or sold, keeps the
// alert's story sponsor and expert answers off.
var researchKeepsSlotsOff = function(row) {
    return Boolean(row && (row.enabled || row.status !== "available"));
};
// Only a real change is saved: an untouched alert has nothing to write.
var researchOfferChanged = function(draft, row) {
    if (researchOfferLocked(row)) return false;
    if (!row) return draft.enabled;
    var _researchDetail;
    return draft.enabled !== Boolean(row.enabled) || draft.pricePence !== row.pricePence || draft.researchDetail.trim() !== ((_researchDetail = row.researchDetail) !== null && _researchDetail !== void 0 ? _researchDetail : "");
};
// What the public box shows. A buyer holding the reservation may go back to
// their own checkout, so for them a reserved slot still shows the form.
var researchBoxView = function(live) {
    var hasToken = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (!(live === null || live === void 0 ? void 0 : live.enabled)) return null;
    if (live.status === "sold") return "sold";
    if (live.status === "reserved" && !hasToken) return "reserved";
    return "available";
};
var RESERVE_ERRORS = {
    IN_PROGRESS: "Your checkout is being prepared, try again in a moment.",
    RESERVED: "Sponsorship being taken, check back shortly.",
    SOLD: "This research has already been sponsored.",
    NOT_OFFERED: "This research is no longer offered for sponsorship."
};
var reserveErrorMessage = function(response) {
    var ref, ref1;
    var known = RESERVE_ERRORS[response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.code];
    if (known) return known;
    if ((response === null || response === void 0 ? void 0 : response.status) === 429) {
        return "Too many attempts, try again in a minute.";
    }
    if ((response === null || response === void 0 ? void 0 : response.status) === 412) {
        return "Our spam check is unavailable, try again shortly.";
    }
    if ((response === null || response === void 0 ? void 0 : response.status) === 503) {
        return "Sponsorship is not available right now. Please try again later.";
    }
    var message = response === null || response === void 0 ? void 0 : (ref1 = response.data) === null || ref1 === void 0 ? void 0 : ref1.message;
    if ([
        400,
        403,
        409
    ].includes(response === null || response === void 0 ? void 0 : response.status) && message) {
        return Array.isArray(message) ? message.join(" ") : message;
    }
    return "Something went wrong. Please try again.";
};
var storageKey = function(alertId) {
    return "research-sponsor-".concat(alertId);
};
// A Stripe session lasts 33 minutes; past this nothing stored can be resumed.
var RESERVATION_MAX_AGE_MS = 35 * 60 * 1000;
// Storage can be blocked (private mode, site data off); the buyer then simply
// can't resume or release, and the slot frees itself when Stripe expires it.
var withStorage = function(type, use) {
    try {
        return use(window[type]);
    } catch (e) {
        return null;
    }
};
var fresh = function(raw, now) {
    try {
        var value = JSON.parse(raw);
        var age = now - value.savedAt;
        return age >= 0 && age < RESERVATION_MAX_AGE_MS ? value : null;
    } catch (e) {
        return null;
    }
};
// The token lives in localStorage, so the cancel page can release it whatever
// tab Stripe returns to; what the buyer typed stays in this tab's sessionStorage.
// Returns { reservationToken, fields }, fields null unless complete; null when
// there is no fresh token.
var parseStoredReservation = function(rawToken, rawFields, now) {
    var ref, ref1;
    var reservationToken = (ref = fresh(rawToken, now)) === null || ref === void 0 ? void 0 : ref.reservationToken;
    if (typeof reservationToken !== "string" || !reservationToken) {
        return null;
    }
    var fields = (ref1 = fresh(rawFields, now)) === null || ref1 === void 0 ? void 0 : ref1.fields;
    var complete = typeof (fields === null || fields === void 0 ? void 0 : fields.sponsorName) === "string" && fields.sponsorName.trim() && typeof fields.email === "string" && fields.email.trim();
    return {
        reservationToken: reservationToken,
        fields: complete ? {
            sponsorName: fields.sponsorName,
            website: typeof fields.website === "string" ? fields.website : "",
            email: fields.email
        } : null
    };
};
var storedReservation = function(alertId) {
    var now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
    return parseStoredReservation(withStorage("localStorage", function(s) {
        return s.getItem(storageKey(alertId));
    }), withStorage("sessionStorage", function(s) {
        return s.getItem(storageKey(alertId));
    }), now);
};
var storeReservation = function(alertId, reservationToken, fields) {
    var savedAt = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Date.now();
    withStorage("localStorage", function(s) {
        return s.setItem(storageKey(alertId), JSON.stringify({
            reservationToken: reservationToken,
            savedAt: savedAt
        }));
    });
    withStorage("sessionStorage", function(s) {
        return s.setItem(storageKey(alertId), JSON.stringify({
            fields: fields,
            savedAt: savedAt
        }));
    });
};
var forgetReservation = function(alertId) {
    withStorage("localStorage", function(s) {
        return s.removeItem(storageKey(alertId));
    });
    withStorage("sessionStorage", function(s) {
        return s.removeItem(storageKey(alertId));
    });
};


/***/ })

}]);